"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
const react_1 = __importStar(require("react"));
const context_1 = require("../../shared/context");
const Status_1 = require("./Status");
const constants_1 = require("../../shared/constants");
const react_router_dom_1 = require("react-router-dom");
const sdk_1 = require("../sdk");
const extensions_1 = require("../extensions");
function renderPageContent(page) {
    var _a;
    let pageContent = page === null || page === void 0 ? void 0 : page.content;
    if (pageContent === constants_1.SSR_HYDRATE_KEYWORD) {
        pageContent = (_a = document.querySelector('.page__content')) === null || _a === void 0 ? void 0 : _a.innerHTML;
    }
    return (react_1.default.createElement("div", { className: "page" },
        react_1.default.createElement("div", { className: "page__title" },
            page.title,
            react_1.default.createElement("div", { className: "page__rating" }, page.rating > 0 ? `+${page.rating}` : page.rating)),
        react_1.default.createElement("div", { className: "page__content", dangerouslySetInnerHTML: { __html: pageContent } })));
}
function renderPageNotFound() {
    return (react_1.default.createElement(Status_1.Status, { code: 404 },
        react_1.default.createElement("div", null, "Page not found.")));
}
function isHydrated() {
    return typeof window !== 'undefined' && window.hydrated;
}
function markAsHydrated() {
    if (typeof window !== 'undefined') {
        window.hydrated = true;
    }
}
function Page() {
    const [page, setPage] = react_1.useState();
    const match = react_router_dom_1.useRouteMatch();
    const pageName = match.params.pageName.toLowerCase();
    const shouldLoadPage = isHydrated() && pageName !== (page === null || page === void 0 ? void 0 : page.name);
    const hydrationRender = typeof window !== 'undefined' && !isHydrated();
    react_1.useEffect(() => {
        extensions_1.initCollapsibles(document.body);
        extensions_1.initTabs(document.body);
        extensions_1.initLinks(document.body);
    });
    if (hydrationRender) {
        markAsHydrated();
    }
    else if (shouldLoadPage) {
        sdk_1.sdk.getPage(pageName)
            .then((loadedPage) => {
            setPage(loadedPage);
            if (typeof window !== 'undefined') {
                window.scrollTo(0, 0);
                document.title = loadedPage.title;
            }
        })
            .catch(sdk_1.sdk.reportClientError);
    }
    return (react_1.default.createElement(context_1.AppContext.Consumer, null, (value) => {
        if (page === null || page === void 0 ? void 0 : page.content) {
            return renderPageContent(page);
        }
        if (value.preloadedData === 'page-not-found') {
            return renderPageNotFound();
        }
        else {
            return renderPageContent(value.preloadedData);
        }
    }));
}
exports.Page = Page;
//# sourceMappingURL=Page.js.map